import script from "./PinGoodsSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./PinGoodsSelector.vue?vue&type=script&setup=true&lang=js"

import "./PinGoodsSelector.vue?vue&type=style&index=0&id=aa0fb078&lang=scss&scoped=true"

import exportComponent from "D:\\work\\project\\万禾项目\\东智\\dongzhistore\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa0fb078"]])

export default __exports__